import { CohortDurationBand } from '@/types/search'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import EuroSymbolOutlinedIcon from '@mui/icons-material/EuroSymbolOutlined'
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined'
import SettingsAccessibilityOutlinedIcon from '@mui/icons-material/SettingsAccessibilityOutlined'
import ShapeLineOutlinedIcon from '@mui/icons-material/ShapeLineOutlined'
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import { RefinementsConfig } from '../types'

export function createTransformBandItems(
  t: (key: string) => string
): (items: RefinementListItem[]) => RefinementListItem[] {
  return (items: RefinementListItem[]) => {
    return items.map((item) => ({
      ...item,
      label: t(
        `course_duration.${item.value as Exclude<NonNullable<CohortDurationBand>, undefined>}`
      ),
    }))
  }
}

export function getRefinementsConfig(
  t: (key: string) => string
): RefinementsConfig {
  const transformBandItems = createTransformBandItems(t)

  return {
    lists: [
      {
        attribute: 'subcategories.name',
        label: t('facet_subcategories'),
        icon: <CategoryOutlinedIcon />,
        limit: 10,
        defaultExpanded: true,
      },
      {
        attribute: 'skills',
        label: t('facet_skills'),
        icon: <SettingsAccessibilityOutlinedIcon />,
        operator: 'and',
        limit: 10,
        searchable: true,
        searchablePlaceholder: t('searchable_placeholder'),
        defaultExpanded: true,
      },
      {
        attribute: 'education_provider.name',
        label: t('facet_education_provider'),
        icon: <LocalLibraryOutlinedIcon />,
        limit: 10,
        searchable: true,
        searchablePlaceholder: t('searchable_placeholder'),
        showMore: true,
        showMoreLimit: 20,
        defaultExpanded: true,
      },
      {
        attribute: 'level',
        label: t('facet_course_level'),
        icon: <BarChartOutlinedIcon />,
        defaultExpanded: true,
      },
      {
        attribute: 'type',
        label: t('facet_course_type'),
        icon: <ShapeLineOutlinedIcon />,
        limit: 10,
        defaultExpanded: true,
      },
      {
        attribute: 'duration.band',
        label: t('facet_course_duration'),
        icon: <AccessTimeOutlinedIcon />,
        limit: 10,
        transformItems: transformBandItems,
        defaultExpanded: true,
      },
      {
        attribute: 'tags.slug',
        label: 'tags',
        icon: <AccessTimeOutlinedIcon />,
        defaultExpanded: false,
        isHidden: true,
      },
    ],
    ranges: [
      {
        attribute: 'prices.amount',
        label: t('facet_price_range'),
        icon: <EuroSymbolOutlinedIcon />,
        defaultExpanded: true,
      },
    ],
  }
}
